import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/AboutUs.css';

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <section className="about-section" id="about">
      <div className="about-inner">
        <div className="about-content">
          <span className="home-badge">{t('about_badge')}</span>
          <h2>{t('about_title')}</h2>
          <p className="about-subtitle">{t('about_subtitle')}</p>
          <div className="about-blocks">
            <div className="about-block">
              <h4>{t('our_mission')}</h4>
              <p>{t('mission_description')}</p>
            </div>
            <div className="about-block">
              <h4>{t('why_we_exist')}</h4>
              <p>{t('why_description')}</p>
            </div>
            <div className="about-block">
              <h4>{t('our_commitment')}</h4>
              <p>{t('commitment_text')}</p>
            </div>
          </div>
          <div className="about-offer">
            <h4>{t('what_we_offer')}</h4>
            <ul>
              <li>✅ {t('offer_features')}</li>
              <li>✅ {t('offer_cost_breakdown')}</li>
              <li>✅ {t('offer_timelines')}</li>
              <li>✅ {t('offer_expert_guidance')}</li>
              <li>✅ {t('offer_bilingual_resources')}</li>
              <li>✅ {t('offer_professional_consultation')}</li>
            </ul>
          </div>
        </div>
        <div className="about-values">
          {[
            { icon: '🔒', title: t('value_secure_title'), desc: t('value_secure_desc') },
            { icon: '⚡', title: t('value_instant_title'), desc: t('value_instant_desc') },
            { icon: '🌐', title: t('value_bilingual_title'), desc: t('value_bilingual_desc') },
            { icon: '📅', title: t('value_updated_title'), desc: t('value_updated_desc') },
          ].map((v, i) => (
            <div key={i} className="about-value-card">
              <div className="avc-icon">{v.icon}</div>
              <h5>{v.title}</h5>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
